import './css/styles.scss';

function kortGridInit() {}

kortGridInit();
